import gql from 'graphql-tag'

export default gql(`
	query getVirtualCardConfig {
    cashAssist {
        getVirtualCardConfig {
          isActive
          classSuffix

          issuerName
          issuerEmail
          programName

          accountIdLabel
          rewardsTierLabel
          rewardsTier
          secondaryRewardsTierLabel
          secondaryRewardsTier

          logoImg
          wideLogoImg
          wideLogoGoogleImg
          heroGoogleImg

          backgroundColor
          foregroundColor
          labelColor
          
          homepageUri {
            description
            link
          }
          linkPhoneUri {
            description
            link
          }

          isDefault
        }
    }
}
`)
